import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { LeftArrow } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
let logo = '/images/logo.png'
import { useTranslation, Trans } from 'react-i18next'
import i18n from 'config/i18n'
import { Content, Title } from './style'

const ModelAgreement = (props) => {
  const { dispatch, user } = props
  const { t } = useTranslation('live', { i18n })

  useEffect(() => {
    if (user?.gender !== 1) {
      dispatch(setMainContent('dashboard'))
    }
  }, [user])

  return (
    <div className='main-content__about-us'>
      <div className='about-us__container'>
        <div className='container__logo' >
          <img className='logo__image' src={logo} />
        </div>
        <Title>
          {t('Model Agreement')}
        </Title>

        <Content>
          <iframe
            src="https://docs.google.com/viewer?url=https://connectmingle.com/documents/model-agreement.pdf&embedded=true"
            type="application/pdf"
            height="100%"
            width="100%"
          >
          </iframe>
        </Content>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
})

export default connect(mapStateToProps)(ModelAgreement)